var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 29.607C47 19.883 39.165 12 29.5 12S12 19.883 12 29.607C12 38.395 18.4 45.679 26.766 47V34.697h-4.444v-5.09h4.444v-3.88c0-4.412 2.612-6.85 6.61-6.85 1.914 0 3.917.345 3.917.345v4.333h-2.207c-2.173 0-2.852 1.357-2.852 2.75v3.302h4.854l-.776 5.09h-4.078V47C40.6 45.68 47 38.395 47 29.607z",
    fill: "#1877F2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Facebook.807a1465.svg";
export { ForwardRef as ReactComponent };